export default __webpack_public_path__ + "images/eab618e3992d420d7c7098a7562c7e6b.svg";